/**
 * 定义用户资源仓库
 */
import {
  asyncRouterMap,
  asyncSystemRouterMap,
  constantRouterMap
} from "@/config/router.config";
import Vue from "vue";

import { ACCOUNT_TYPE, ACCOUNT_TYPE_INFO, USER_INFO } from "./mutaion-types.js";

function hasPermission(permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false;

    if (route.meta.permission == "contract_template") {
      let info = Vue.ls.get(USER_INFO);
      if (info && info.userType == 2) {
        return false;
      }
      return true;
    }
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i]);
      if (flag) {
        return true;
      }
    }
    return false;
  }
  return true;
}

function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id);
  } else {
    return true;
  }
}

function filterAsyncRouter(routerMap, permsissions) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(permsissions, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permsissions);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}

const permission = {
  state: {
    routers: constantRouterMap, //默认路由
    addRouters: [] //有权限的路由
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { permsissions } = data;
        let type = Vue.ls.get(ACCOUNT_TYPE);
        let route =
          type == ACCOUNT_TYPE_INFO.NORMAL
            ? asyncRouterMap
            : asyncSystemRouterMap;
        const accessedRouters = filterAsyncRouter(route, permsissions);
        commit("SET_ROUTERS", accessedRouters);
        resolve();
      });
    }
  }
};

export default permission;
